import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { costsApi } from '../api/costs.api';
import type { CostEstimate, CostTariffs } from '../interfaces/costs.interface';

/** Tarifele standard (nu depind de firmă). */
export function useCostTariffs() {
  const { direction } = useDirection();
  return useQuery<CostTariffs>({
    queryKey: ['costs', 'tariffs', direction],
    queryFn: () => costsApi.tariffs(direction),
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/** Estimarea pe booking-urile firmei selectate (sau ale tuturor firmelor contului). */
export function useCostEstimate() {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;
  return useQuery<CostEstimate>({
    queryKey: ['costs', 'estimate', selectedCompanyId, direction],
    queryFn: () => costsApi.estimate(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
